import { LOAN_TYPE_BUSINESS, LOAN_TYPE_MORTGAGE } from "@/lib/constants";
import { useFormDataStore } from "@/components/context/useFormContext";
import { BusinessLoanDetails } from "@/components/forms/quickForm/parts/business/loanDetailsStep";
import { DefaultLoanDetails } from "@/components/forms/quickForm/parts/default/loanDetailsStep";
import { MortgageLoanDetails } from "@/components/forms/quickForm/parts/mortgage/loanDetailsStep";

export const LoanDetails = () => {
	const { formValues } = useFormDataStore();

	return (
		<div className="jF-space-y-2">
			{formValues.loanType === LOAN_TYPE_BUSINESS ? (
				/* Business Loan */
				<BusinessLoanDetails />
			) : formValues.loanType === LOAN_TYPE_MORTGAGE ? (
				/* Mortgage Loan */
				<MortgageLoanDetails />
			) : (
				/* Other Loan Types */
				<DefaultLoanDetails />
			)}
		</div>
	);
};
